import React, { useEffect, useState, useRef, createContext, useContext } from 'react';
import useSound from 'use-sound';
const AudioPlayerContext = createContext(null);
export function AudioPlayerProvider({
  children
}) {
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  // We need to handle the case when there's no track yet
  const [play, {
    pause,
    duration: soundDuration,
    sound
  }] = useSound(currentTrack?.audioSrc || 'https://example.com/placeholder.mp3', {
    volume: 1,
    onplay: () => setIsPlaying(true),
    onpause: () => setIsPlaying(false),
    onend: () => setIsPlaying(false),
    onload: () => {
      if (soundDuration) setDuration(soundDuration / 1000);
    }
  });
  // Update time tracking
  useEffect(() => {
    const interval = setInterval(() => {
      if (sound && isPlaying) {
        setCurrentTime(sound.seek());
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [sound, isPlaying]);
  const togglePlayPause = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };
  const skipForward = () => {
    if (sound) {
      const newTime = Math.min(sound.seek() + 10, duration);
      sound.seek(newTime);
      setCurrentTime(newTime);
    }
  };
  const skipBackward = () => {
    if (sound) {
      const newTime = Math.max(sound.seek() - 10, 0);
      sound.seek(newTime);
      setCurrentTime(newTime);
    }
  };
  const setProgress = percent => {
    if (sound) {
      const newTime = percent / 100 * duration;
      sound.seek(newTime);
      setCurrentTime(newTime);
    }
  };
  return <AudioPlayerContext.Provider value={{
    currentTrack,
    setCurrentTrack,
    isPlaying,
    togglePlayPause,
    currentTime,
    duration,
    skipForward,
    skipBackward,
    setProgress
  }} data-id="element-112">
      {children}
    </AudioPlayerContext.Provider>;
}
export function useAudioPlayer() {
  const context = useContext(AudioPlayerContext);
  if (!context) {
    throw new Error('useAudioPlayer must be used within an AudioPlayerProvider');
  }
  return context;
}